import { action } from 'satcheljs';

/**
 * Shows the delete modal and sets it's calendarItem
 */
let showItemDeleteModal = action('showItemDeleteModal', (itemId: string) => ({ itemId: itemId }));

export default showItemDeleteModal;
